<div
  fxLayout="row"
  fxLayout.xs="column"
  fxLayoutGap="25px"
  fxLayoutGap.xs="0"
  [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
  <div fxFlex="33.333333%" fxFlex.xs="100%" class="col">
    <mat-card class="single-stats-box tagus-card mb-25">
      <div class="d-flex justify-content-space-between align-items-center">
        <div class="title">
          <h3>R$0</h3>
          <span class="d-block gray-color">Notas emitidas</span>
        </div>
        <div class="icon">
          <i class="flaticon-donut-chart"></i>
        </div>
      </div>
      <p class="position-relative up">
        <i class="flaticon-trend"></i> <span>1.3%</span> Acima da semana passada
      </p>
    </mat-card>
  </div>
  <div fxFlex="33.333333%" fxFlex.xs="100%" class="col">
    <mat-card class="single-stats-box tagus-card mb-25">
      <div class="d-flex justify-content-space-between align-items-center">
        <div class="title">
          <h3>R$0</h3>
          <span class="d-block gray-color">Notas em análise</span>
        </div>
        <div class="icon">
          <i class="flaticon-goal"></i>
        </div>
      </div>
      <p class="position-relative up">
        <i class="flaticon-trend"></i> <span>0%</span> Acima da semana passada
      </p>
    </mat-card>
  </div>
  <div fxFlex="33.333333%" fxFlex.xs="100%" class="col">
    <mat-card class="single-stats-box tagus-card mb-25">
      <div class="d-flex justify-content-space-between align-items-center">
        <div class="title">
          <h3>R$0</h3>
          <span class="d-block gray-color">Notas pagas</span>
        </div>
        <div class="icon">
          <i class="flaticon-award"></i>
        </div>
      </div>
      <p class="position-relative down">
        <i class="flaticon-trend-1"></i> <span>0%</span> Abaixo da semana
        passada
      </p>
    </mat-card>
  </div>
</div>
